import { render, staticRenderFns } from "./MessageIconInformation.vue?vue&type=template&id=7baa405a"
import script from "./MessageIconInformation.vue?vue&type=script&lang=js"
export * from "./MessageIconInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports